import * as actionTypes from "../actions/actionTypes";
import { updateObject } from "../utility";

const initialState = {
    needAnalysisData :{},
    "Topgoal": {
        "Primary_product": [
            {
                "productName": ""
            }
        ],
        "Secondary_product": [
            {
                "productName": ""
            },
            {
                "productName": ""
            }
        ]
    },
    "Secondgoal": {
        "Primary_product": [
            {
                "productName": ""
            }
        ],
        "Secondary_product": [
            {
                "productName": ""
            },
            {
                "productName": ""
            }
        ]
    },
    "Thirdgoal": {
        "Primary_product": [
            {
                "productName": ""
            }
        ],
        "Secondary_product": [
            {
                "productName": ""
            },
            {
                "productName": ""
            }
        ]
    },
    "Clicked_product": "",
    "needAnalysisForm": ""
}


const storeNeedAnalysisData = (state,action)=>{
    return updateObject(state,{
        needAnalysisData:action,
    })
}

const addRecommendedProducts = (state, action) => {
    return updateObject(state, {
      ...action.payload
    });
  };

  const deleteOldRecommendedProducts = (state, action) => {
    return updateObject(state, {
        "Topgoal": {
            "Primary_product": [
                {
                    "productName": ""
                }
            ],
            "Secondary_product": [
                {
                    "productName": ""
                },
                {
                    "productName": ""
                }
            ]
        },
        "Secondgoal": {
            "Primary_product": [
                {
                    "productName": ""
                }
            ],
            "Secondary_product": [
                {
                    "productName": ""
                },
                {
                    "productName": ""
                }
            ]
        },
        "Thirdgoal": {
            "Primary_product": [
                {
                    "productName": ""
                }
            ],
            "Secondary_product": [
                {
                    "productName": ""
                },
                {
                    "productName": ""
                }
            ]
        },
        "Clicked_product": ""
    });
  };

const reducer = (state = initialState, action) => {
    switch (action.type) {
      // lead
      case actionTypes.FETCH_NEED_ANALYSIS_DATA:
        return storeNeedAnalysisData(state,action);
      case actionTypes.ADD_RECOMMENDED_PRODUCTS:
        return addRecommendedProducts(state, action);
        case actionTypes.DELETE_OLD_RECOMMENDED_PRODUCTS:
        return deleteOldRecommendedProducts(state, action);
  
      default:
        return state;
    }
  };
  
  export default reducer;


